import { BlockedActionType, SigningModeType, Variant } from '@fiverr-private/identification_core';
import { CopyKey } from '../../i18n';

export const BLOCKED_ACTION_MOBILE_LABEL_MAP: Record<
    SigningModeType,
    Record<Exclude<BlockedActionType, 'new_brief_and_match'>, CopyKey>
> = {
    sign_in: {
        contact_seller: `steps.initial.blocked_action_title_when_sign_in.contact_seller`,
        continue_to_checkout: `steps.initial.blocked_action_title_when_sign_in.checkout`,
        save_to_list: `steps.initial.blocked_action_title_when_sign_in.save_favorite`,
        post_a_brief: `steps.initial.blocked_action_title_when_sign_in.post_brief`,
        become_a_seller: `steps.initial.blocked_action_title_when_sign_in.become_a_seller`,
    },
    sign_up: {
        contact_seller: `steps.initial.blocked_action_title_when_sign_up.contact_seller`,
        continue_to_checkout: `steps.initial.blocked_action_title_when_sign_up.checkout`,
        save_to_list: `steps.initial.blocked_action_title_when_sign_up.save_favorite`,
        post_a_brief: `steps.initial.blocked_action_title_when_sign_up.post_brief`,
        become_a_seller: `steps.initial.blocked_action_title_when_sign_up.become_a_seller`,
    },
};

export const TRANSLATION_KEYS = {
    onboarding: {
        sign_up: {
            titleKey: 'steps.initial.variant_onboarding.title_when_sign_up',
            subtitleKey: 'steps.initial.variant_onboarding.subtitle_when_sign_up',
        },
        sign_in: {
            titleKey: 'steps.initial.title_when_sign_in',
            subtitleKey: 'steps.initial.subtitle_when_sign_in_2',
        },
    },
    go: {
        sign_up: {
            titleKey: 'steps.initial.variant_go.title_when_sign_up',
            subtitleKey: 'steps.initial.variant_go.subtitle_when_sign_up',
        },
        sign_in: {
            titleKey: 'steps.initial.title_when_sign_in',
            subtitleKey: 'steps.initial.subtitle_when_sign_in_2',
        },
    } as const,
    default: {
        sign_up: {
            titleKey: 'steps.initial.title_when_sign_up',
            subtitleKey: 'steps.initial.subtitle_when_sign_up_2',
        },
        sign_in: {
            titleKey: 'steps.initial.title_when_sign_in',
            subtitleKey: 'steps.initial.subtitle_when_sign_in_2',
        },
    } as const,
} satisfies Partial<Record<Variant, Record<SigningModeType, { titleKey: CopyKey; subtitleKey: CopyKey }>>>;
